<template>
  <div class="action-row flex">
    <div
      v-for="(cell, index) in row"
      :key="index"
      :class="index ? 'cell-size cell-borders' : 'cell-size'"
      class="action items-center flex-col"
    >
      <template v-if="cell">
        <div
          class="price w-full flex flex-col items-center justify-center px-6 py-4 shadow-widget"
          :class="{ 'bg-caramel-neutral-100': cell }"
        >
          <div class="text-center prefix">
            {{ $t('widget.priceTable.pricePrefix') }}
          </div>

          <div class="amount">{{ $n(cell.baseMonthlyPrice) }} €</div>

          <div class="text-center suffix">
            {{ $t('widget.priceTable.priceSuffix') }}
            <sup>*</sup>
          </div>
        </div>

        <template v-if="hasSession">
          <a
            :href="getOrderUrl(cell)"
            class="button button--primary mt-6 md:mt-8"
          >
            {{ $t('widget.priceTable.callToActionOrder') }}
          </a>

          <a
            :href="getInfoUrl(cell)"
            class="button button--text mt-6 md:mt-8"
            >{{ $t('widget.priceTable.callToActionInfo') }}</a
          >
        </template>

        <template v-else>
          <a :href="getInfoUrl(cell)" class="button button--text mt-6 md:mt-8">
            {{ $t('widget.priceTable.callToActionInfo') }}
          </a>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { parseInfoUrl, parseOrderUrl } from '../core/utils'

export default {
  props: ['row', 'environment', 'hasSession'],
  methods: {
    getInfoUrl(cell) {
      return parseInfoUrl(this.environment, cell.planCode)
    },
    getOrderUrl(cell) {
      return parseOrderUrl(this.environment, cell.planCode)
    },
  },
}
</script>

<style src="../tailwind.css" scoped></style>
<style lang="scss" src="../styles/ActionRow.scss"></style>
